module.exports = __webpack_public_path__ + "static/media/diageo_header-logo.8dcf0d95.png";